import { Cell } from './types';
import styled from 'styled-components';
import { FlexRow, BaseCol, H4, BlankLink, Subtext, Styles } from 'toolkit/components';

const A = styled.a`
  color: ${Styles.colors.blue.primary};
`;

const TitleCell = ({ cell }: Cell) => {
  const { publishedToUrl, creator, title, id } = cell.row.original;

  return (
    <div>
      <FlexRow align="left">
        <BaseCol default={10}>
          <A href={`${window.origin}/stories/${id}`}>
            <H4>{title}</H4>
          </A>
        </BaseCol>
        <BaseCol default={1}>
          {publishedToUrl && <BlankLink href={publishedToUrl} title={publishedToUrl} />}
        </BaseCol>
      </FlexRow>
      <Subtext>By {creator}</Subtext>
    </div>
  );
};

export default TitleCell;
